import React from 'react';
import { Transition, type TransitionStatus } from 'react-transition-group';
import { cs } from '@bbkAdminUtils/css-utils';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';

const durationDefault = 300;
const durationClassNameByMs: Record<number, string> = {
  75: 'tw-duration-75',
  100: 'tw-duration-100',
  150: 'tw-duration-150',
  200: 'tw-duration-200',
  300: 'tw-duration-300',
  500: 'tw-duration-500',
  700: 'tw-duration-700',
  1000: 'tw-duration-1000',
};

const opacityClassNameByState: Record<TransitionStatus, string> = {
  entering: 'tw-opacity-100',
  entered: 'tw-opacity-100',
  exiting: 'tw-opacity-0',
  exited: 'tw-opacity-0',
  unmounted: 'tw-opacity-0',
};

type Props = {
  in: boolean;
  duration?: number;
  mountOnEnter?: boolean;
  unmountOnExit?: boolean;
};
const Fade: ReactFCC<Props> = ({
  in: inProp,
  children,
  duration = durationDefault,
  mountOnEnter,
  unmountOnExit,
}) => {
  const durationClassName =
    durationClassNameByMs[duration] ?? durationClassNameByMs[durationDefault];

  return (
    <Transition
      in={inProp}
      timeout={duration}
      mountOnEnter={mountOnEnter}
      unmountOnExit={unmountOnExit}
    >
      {(state) => (
        <div
          className={cs(
            'tw-opacity-0 tw-transition-opacity tw-ease-in-out',
            durationClassName,
            opacityClassNameByState[state]
          )}
        >
          {children}
        </div>
      )}
    </Transition>
  );
};

Fade.defaultProps = {
  mountOnEnter: false,
  unmountOnExit: false,
};

export default Fade;
